const supportedImageTypes = ['jpg', 'jpeg', 'png', 'gif'];
const supportedVideoTypes = ['mp4', 'm4v', 'webm', 'mov'];

type MediaViewerMetadata = {
  cdn01?: string;
  image?: string;
  video?: string;
};

type MediaViewerProps = {
  metadata?: MediaViewerMetadata | null;
  className?: string;
  width?: string;
  height?: string;
};

const getExtension = (path?: string): string =>
  path ? path.split('.').pop()?.toLowerCase() ?? '' : '';

const MediaViewer = ({
  metadata,
  className = '',
  width,
  height,
}: MediaViewerProps) => {
  if (!metadata) {
    return (
      <div className="mediaViewer">
        <div>No media specified.</div>
      </div>
    );
  }

  const linkExtension = getExtension(metadata.video ?? metadata.image);
  const imageLink = `${metadata.cdn01 ?? ''}${metadata.image ?? ''}`;
  const videoLink = `${metadata.cdn01 ?? ''}${metadata.video ?? ''}`;

  if (supportedImageTypes.includes(linkExtension)) {
    return (
      <div className={`mediaViewer ${className}`} style={{ width, height }}>
        <a target="_blank" rel="noreferrer" href={imageLink}>
          <div
            style={{
              backgroundImage: `url("${imageLink}")`,
              width,
              height,
            }}
          />
        </a>
      </div>
    );
  }

  if (supportedVideoTypes.includes(linkExtension)) {
    return (
      <div className={`mediaViewer ${className}`}>
        <a target="_blank" rel="noreferrer" href={videoLink}>
          <video preload="auto" controls>
            <source src={videoLink} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </a>
      </div>
    );
  }

  // user published something weird or old here, try to adapt
  const link = metadata.video ?? metadata.image ?? '';

  return (
    <div className={`mediaViewer ${className}`}>
      <a target="_blank" rel="noreferrer" href={link}>
        <div>No preview available.</div>
      </a>
    </div>
  );
};

export default MediaViewer;
